export const ApiConfigs = {
    //base_url: 'http://127.0.0.1:8000/api',
    base_url: process.env.VUE_APP_API_URL+'/api',
    /* -------------------------------- */
    // PUSHER
    pusher: {
        auth: '/auth',
    },
    // Batches
    batch: {
        getAll: '/batches',
        getById: '/batches/:id',
        create: '/batches/create',
        update: '/batches/:id/update',
        delete: '/batches/:id/delete'
    },
    type: {
        getAll: '/types',
        getById: '/types/:id',
        create: '/types/create',
        update: '/types/:id/update',
        delete: '/types/:id/delete',
    },
    brand: {
        getAll: '/brands',
        getById: '/brands/:id',
        create: '/brands/create',
        update: '/brands/:id/update',
        delete: '/brands/:id/delete',
    },
    voucher: {
        getAll: '/voucher',
        getById: '/voucher/:id',
        create: '/voucher/create',
        update: '/voucher/:id/update',
        delete: '/voucher/:id/delete',
    },
    statuses: {
        getAll: '/statuses',
        getById: '/statuses/:id',
        create: '/statuses/create',
        update: '/statuses/:id/update',
        delete: '/statuses/:id/delete',
    },

    size: {
        getAll: '/sizes',
        getByType: '/sizes/type/:id',
        getById: '/sizes/:id',
        create: '/sizes/create',
        update: '/sizes/:id/update',
        delete: '/sizes/:id/delete',
    },
    color: {
        getAll: '/colors',
        getById: '/colors/:id',
        create: '/colors/create',
        update: '/colors/:id/update',
        delete: '/colors/:id/delete',
    },
    order: {
        getAll: '/shop/order',
        getAllByUser: '/shop/orders',
        getById: '/shop/order/:id',
        create: '/shop/order/create',
        update: '/shop/order/:id/update',
        delete: '/shop/order/:id/delete',
        confirm: '/shop/orders/confirm',
        admin: {
            getAll: '/order/admin',
            getAllByStatus: '/order/admin/status/:status',
            getById: '/order/admin/:id',
            create: '/order/admin/create',
            update: '/order/admin/:id/update',
            delete: '/order/admin/:id/delete',
        }
    },
    team: {
        getAll: '/team',
        getById: '/team/:id',
        create: '/team/create',
        update: '/team/:id/update',
        delete: '/team/:id/delete',
    },
    provider: {
        getAll: '/providers',
    },
    users: {
        getAll: '/users'
    },
    product: {
        getAll: '/products',
        getById: '/products/:id',
        create: '/products/create',
        update: '/products/:id/update',
        delete: '/products/delete/:id'
    },
    // Menu
    menu: {
        getAll: '/menu/menu',
    },
    sms: {
        getCurrentProvider: '/settings',
        update: '/settings/sms-provider'
    },
    shop: {
        login: '/shop/login',
        register: '/shop/register',
        verify: '/shop/verify',
        products: '/shop/products',
        swipe: '/shop/swipe/:id/:action',
        cart: '/shop/cart',
        remove_item: '/shop/cart/product/:id/remove',
        getProfileInfo: '/shop/check-subscription',
        getVoucher: '/shop/get-voucher'
    },
    user: {
        update_profile_infomation: '/shop/profile/:id/update',
        getAllAddresses: '/shop/profile/addresses',
        addNewAddress: '/shop/profile/address/add',
        updateAddress: '/shop/profile/address/:id/update',
        deleteAddress: '/shop/profile/address/:id/delete',
        getDna: '/shop/profile/dna',
        createDna: '/shop/profile/dna/create',
        getSizes: '/shop/profile/dna/sizes',
        getUnsetSizes: '/shop/profile/dna/unsetSizes',
        updateSizes: '/shop/profile/dna/sizes/update',
        getAll: '/shopuser',
        getById: '/shopuser/:id',
        update: '/shopuser/:id/update',
        delete: '/shopuser/:id/delete',
        updateWallet: '/shopuser/updatewallet',
        updateUserSub: '/shopuser/change-user-shop-subscription'
    },
    // Advertisement
    ads: {
        getAll: '/ads',
        getById: '/ads/:id',
        create: '/ads/create',
        update: '/ads/:id/update',
        delete: '/ads/:id/delete'
    },
    // Subscriptions
    subscription: {
        getAll: '/subscriptions',
        getById: '/subscriptions/:id',
        create: '/subscriptions/create',
        update: '/subscriptions/:id/update',
        delete: '/subscriptions/:id/delete'
    },

};
